var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("I'm Marc, a "+_vm._s(_vm._calculateAge())+" years old IoT student.")]),_c('p',[_vm._v("I speak German, English, a very tiny amount of French, as well as "+_vm._s(_vm.$store.state.languagesText))]),_c('p',[_c('router-link',{attrs:{"id":"back","title":"◄ go back","to":"/"}},[_vm._v("◄ back")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }